import { Component, OnInit, Input, ViewChild, Output, EventEmitter, HostListener, AfterViewInit, OnDestroy, SimpleChange, OnChanges, SimpleChanges } from '@angular/core';
// import { CourseService } from 'src/app/services/course.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { config } from 'src/app/config';
// import { Store } from 'store';
// import { User } from 'src/app/models/user.model';
import { CountupTimerService } from 'ngx-timer';
import { ScrollToService, ScrollToConfigOptions } from '@nicky-lenaers/ngx-scroll-to';
import { Subject, Subscription } from 'rxjs';
// import { Exercise, ElementType } from 'src/app/models/exercise.model';
// import { DashboardService } from 'src/app/services/dashboard.service';
// import { CommunicationService } from '../services/communication.service';
import { QuestionVideoFeedbackComponent } from '../question-video-feedback/question-video-feedback.component';
import { ElementType, Exercise } from '../../models/exercise.model';
import { FeedbackService } from '../../services/feedback.service';
import { CommunicationService } from '../../services/communication.service';
import { DashboardService } from '../../services/dashboard.service';
import { Store } from 'src/app/core/store/store';
import { CourseService } from '../../services/course.service';
import { SelfAssessmentService } from '../../services/self-assessment.service';
import { UtilityService } from '../../utils/utility.service';
import { PathwayService } from '../../services/pathway.service';
import { User } from '../../models/user.model';
import { ReportFeedbackComponent } from '../report-feedback/report-feedback.component';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { EventsService } from '../../services/events.service';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
// import { FeedbackService } from '../services/feedback.service';
// import { ReportFeedbackComponent } from '../report-feedback/report-feedback.component';
// import { SelfAssessmentService } from 'src/app/self-assessments/services/self-assessment.service';
// import { UtilityService } from 'src/app/services/utility.service';
// import { PathwayService } from 'src/app/services/pathway.service';
// declare var amplitude;
declare var ga;
declare var mixpanel;

@Component({
  selector: 'app-exercise',
  templateUrl: './exercise.component.html',
  styleUrls: ['./exercise.component.css']
})
export class ExerciseComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @HostListener('window:resize', ['$event'])
  public windowresized($event) {
    this.toggleSlick();
  }

  @Input() exerciseData: Exercise;
  @Input() isResultPublished: boolean = false;
  @Input() isSubmitted: boolean = false;
  @Input() savedTime: number = 0;
  @Input() type;
  @Input() courseId;
  @Input() courseTitle;
  @Input() nextItemId;
  @Input() currItem;
  @Input() points = {};
  @Input() answers = {};
  @Input() taFeedbacks = {};
  @Input() correctAnswers = {};
  @Input() courseFeedback = {};
  @Input() variableFeedback = {};
  @Input() activationData;
  @Input() activationInfoData = {};
  @Input() isSelfAssessment: boolean = false;
  isCurrentItemLocked: boolean = false
  @ViewChild('slickModal') slickModal: any;
  stopCameraTag = {
    change: false,
    stop: false
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.keyCode == 9) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return;
    }
  }

  @Output() isExerciseSubmited = new EventEmitter<boolean>();
  @Output() asessmentSubmited = new EventEmitter<any>();
  showSlick: boolean = true;
  showBackButton: boolean = false;
  modalRef: any;
  user: User;
  courseContent;
  activeNode = null;
  userSubscription: Subscription;
  courseSubscription: Subscription;
  subscriptions: Subscription;
  totalQuestions: any[] = [];
  slideConfig = {
    dots: false,
    arrows: false,
    accessibility: false,
    swipe: false,
    touchMove: false,
    fade: true,
    draggable: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 767,
      settings: {
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    ]
  };
  answersArray: any[] = [];
  timer = {
    min: 0,
    sec: 0,
    totalTime: 0
  }

  slick = {
    currentSlide: 0
  };
  currentSlideNumber = 0;
  immediateFeedBackRequired: boolean = false;
  @Input() isPrePostExercise = false;
  @Input() activationInfo: any;
  courseName: string;
  programActivationId = null;
  unsubscribe$ = new Subject<void>();
  currentUserCourse: any;
  @Input() exerciseType;
  exerciseTimetrackingdata = {};
  @Input() isAssessmentExercise = false;
  @Input() programDashboardId;


  constructor(private feedbackService: FeedbackService, private communicationService: CommunicationService, private dashboardService: DashboardService, private store: Store, private modalService: NgbModal, private courseService: CourseService, private assessmentService: SelfAssessmentService, private countupTimerService: CountupTimerService, private _scrollToService: ScrollToService, private utilityService: UtilityService, private pathwayService: PathwayService, 
    private eventsService: EventsService,private activatedRoute:ActivatedRoute) {
  }


  ngOnInit() {
    // console.log(this.exerciseData, 'exerciseDataexerciseDataexerciseDataexerciseDataexerciseDataexerciseData')
    this.store.select('currentUserCourse').pipe(takeUntil(this.unsubscribe$)).subscribe((course: any) => {
      if (course) {
        this.programActivationId = course.programActivationId;
        this.currentUserCourse = course;
      }
    });
    this.store.select('programData').pipe(filter(program => program != undefined || program != null), takeUntil(this.unsubscribe$)).subscribe((activation: any) => {
      if(activation) {
        this.activationData = activation;
        if(this.activationData){
          this.setTimetrackingObj(this.activationData,this.exerciseType);
        }
      }
    });
    // remove outside isSelfAssessment block to capture event
    this.userSubscription = this.store.select<User>('user').subscribe(user => {
      if (user) {
        this.user = user;
      }
    });
    
    if (!this.isSelfAssessment) {

      this.courseSubscription = this.store.select('course').subscribe((data) => {
        this.courseContent = data['contents'];
        this.utilityService.TrackingData = { cTitle: data['title'], eTitle: this.exerciseData['exerciseName'] }
        this.courseName = data['title'];
      });
    }
    if(this.exerciseData && this.exerciseData['elements'] && this.exerciseData['elements'].length) {
      this.exerciseData['elements'] = this.exerciseData['elements']
      this.totalQuestions = this.exerciseData?.['elements'].filter(elem => elem.elementType != 'EDITOR');
    } else {
      this.exerciseData['elements'] = this.exerciseData['elements']
    }
    if (this.totalQuestions) {
      this.communicationService.setLastQuestionId(this.totalQuestions[this.totalQuestions.length - 1]?._id)
    }
  }

  setTimetrackingObj(data,type){
    let ongingAssessment:any;
    this.activatedRoute.params.subscribe(ele=>{
      if (type === 'ASSESSMENT' && ele['id']) {
        ongingAssessment = this.activationData.find((q) => (q.type === 'ASSESSMENT') && (q.exerciseId === ele['id']));
      }
    });
    // console.log(this.activationInfo);
    data.forEach((val,key) => {
      if(val.type == type){
        this.exerciseTimetrackingdata['eventType'] = "PROG-"+type;
        this.exerciseTimetrackingdata['programDashboardId'] = ongingAssessment ? ongingAssessment?.programDashboardId : val.programDashboardId;
        this.exerciseTimetrackingdata['exerciseId'] = ongingAssessment ? ongingAssessment?.exerciseId :val.exerciseId;
        this.exerciseTimetrackingdata['exerciseTemplateName'] =ongingAssessment? ongingAssessment?.exercise?.templateName : val.exerciseTemplateName;
      }
    });
    this.exerciseTimetrackingdata['programActivationId'] = this.activationInfo['programActivationId'];
    this.exerciseTimetrackingdata['organization'] = this.activationInfo['organization'];
    // this.exerciseTimetrackingdata['questionNumber'] = (this.slick.currentSlide+1);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.exerciseData && !changes.exerciseData.isFirstChange()) {
      this.subscriptions && this.subscriptions.unsubscribe();
      this.toggleSlick();
      this.populateExercise();
    }
  }
  ngAfterViewInit() {
    setTimeout(() => { this.populateExercise() }, 1000);
  }

  populateExercise() {
    this.updateIndex(0);
    this.answersArray = [];
    this.subscriptions = new Subscription();
    if(this.exerciseData && this.exerciseData.pages && this.exerciseData.pages.length) {
      this.activeNode =  this.exerciseData.pages[0].elements[0];
    }
    this.communicationService.changeNode(this.activeNode);
    this.immediateFeedBackRequired = this.exerciseData.showImmediateFeedaback;
    if (this.totalQuestions && this.totalQuestions.length) {
      this.startTimer(this.savedTime);
      Object.keys(this.answers).forEach(k => {
        let item = { elementId: k, answer: this.answers[k], total: 0, points: 0, };
        this.updateAnswersArray(item);
      });
      this.setUnAttemptedAnswersInCommunicationService();
      if (this.answersArray.length && (this.exerciseData && this.exerciseData['elements'].length)) {
        let lastSavedQuestionSlide = this.exerciseData['elements'].findIndex(el => el._id == this.answersArray[this.answersArray.length - 1].elementId)
        if (lastSavedQuestionSlide > -1 && this.slickModal) {
          this.slickModal.slickGoTo(lastSavedQuestionSlide, false);
        }
      }
    }
  }

  update() {
    let ans = Object.keys(this.answers).filter(k => this.answers[k]).map(k => ({ elementId: k, answer: this.answers[k] }))
    console.log(ans.length, this.totalQuestions.length ,this.exerciseData.isAllQuestionMandatory, 'this.isPrePostExercisethis.isPrePostExercise')
    if (ans.length != this.totalQuestions.length && this.exerciseData.isAllQuestionMandatory) {
      this.courseService.setcurrentPlayedItem(this.nextItemId);
    }
    // Submit benchmarking pre/post exercise
    else if (this.isPrePostExercise) {

      let obj = {
        programId: this.activationInfo.programId,
        activationId: this.activationInfo.programActivationId,
        exerciseType: this.exerciseType,
        exerciseId: this.exerciseData['exerciseId'], answers: this.answersArray, timeSpent: this.timer.totalTime
      }
      this.subscriptions.add(this.pathwayService.submitPrePostExercise(obj).subscribe(res => {
        if (res) {
          this.asessmentSubmited.emit(res);
          // capture events
          try {
            if(this.exerciseData && this.totalQuestions.length && this.user && this.activationData) {
              let blockObj = this.activationData.find(x => x.exerciseId == this.exerciseData._id); 
              let eventData = { 'exerciseData': this.exerciseData, 'exerciseLength': this.totalQuestions.length, 'user': this.user,  
              'activationData': this.activationData, blockItem: blockObj }
              if(this.exerciseType == 'PRE'){ 
                this.eventsService.submitPreTestEvent(eventData);
              }
              else if(this.exerciseType == 'POST'){
                this.eventsService.submitPostTestEvent(eventData);
              }
            }
          } catch (err) {
            console.log(err);  
          }
        }
      }));
    } 
    else if(this.isAssessmentExercise) {
      let obj = {
        programDashboardId: this.programDashboardId,
        programActivationId: this.activationInfo.programActivationId,
        exerciseType: this.exerciseType,
        exerciseId: this.exerciseData._id,
        answers: this.answersArray, timeSpent: this.timer.totalTime, contentCompleted: true
      }
      this.subscriptions.add(this.pathwayService.saveAssessmentExer(obj).subscribe(res => {
        if (res) {
          this.asessmentSubmited.emit(res);
        }
      }));
    }
    else {
      this.updateExerciseProgress(ans);
    }
  }

  scrolltoTop() {
    const config: ScrollToConfigOptions = {
      target: 'destination'
    };
    this._scrollToService.scrollTo(config)
  }

  ngOnDestroy(): void {
    this.userSubscription && this.userSubscription.unsubscribe();
    this.subscriptions && this.subscriptions.unsubscribe();
    this.courseSubscription && this.courseSubscription.unsubscribe();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  updateExerciseProgress(answers, isCompleted = true) {
    if (this.isSelfAssessment) {
      this.asessmentSubmited.emit(answers);
    } else {
      this.subscriptions.add(this.courseService.updateProgress(this.programActivationId, this.courseId, this.currItem.id, isCompleted, true, answers, this.timer.totalTime).subscribe(res => {
        if (res) {
          this.checkModuleCompleted(res)
          this.exerciseSaveEventAmplitude();
          this.isExerciseSubmited.emit(true);
        }
      }));
    }
  }


  checkModuleCompleted(user) {
    // let courseIndex = user.visitedCourses.findIndex(course => course.id == this.courseId);
    let contentCompleted = [];
    // if (courseIndex != -1) {
      // contentCompleted = user.visitedCourses[courseIndex].contentsCompleted;
      contentCompleted = this.currentUserCourse && this.currentUserCourse.contentsCompleted;
      let isCompleted = true;
      for (let i = 0; i < this.courseContent.length; i++) {
        if (this.courseContent[i].moduleName == this.currItem.moduleName) {
          if (!contentCompleted.includes(this.courseContent[i].id)) {
            isCompleted = false;
            break;
          }
        }
      }
      if (isCompleted) {
        this.amplitudeModuleComplete();
      }
    // }
  }

  amplitudeModuleComplete() {
    // this.amplitudeIntialization();
    /* amplitude.getInstance().logEvent('ModuleCompleted', {
      'ModuleName': this.currItem.moduleName,
      'Course Name': this.courseTitle,
      'timeStamp': new Date()
    }); */
    /* mixpanel.track('Module Completion', {
      'Module Name': this.currItem.moduleName,
      'Module Number': this.currItem.moduleNumber,
      'Course Name': this.courseTitle,
    }); */
  }


  amplitudeIntialization() {
    /* amplitude.getInstance().init(config.AMPLITUDE_API_KEY);
    amplitude.getInstance().setUserId(this.user.email); */
  }

  gotoEnd() {
    if(this.exerciseData && this.exerciseData['elementCount']) {
      this.slickModal.slickGoTo(this.exerciseData['elementCount'], false)
    }
  }

  testComplete= false;

  elementOutput(event) {
    this.stopAllMediaPlayers();
    if (typeof event === 'object' && event !== null) {
      if (event.answer && !(event.answer === '{}' || (event.answer === undefined) || this.isEmptyJsonString(event.answer))) {
        this.answers[event.elementId] = event.answer;
        let item = { elementId: event.elementId, answer: event.answer, total: 0, points: 0 };
        this.updateAnswersArray(item);
        this.setUnAttemptedAnswersInCommunicationService();
        if (!this.isSelfAssessment) {
          this.saveExercise();
        }
        if ((this.answersArray && this.answersArray.length) == (this.totalQuestions && this.totalQuestions.length)) {
          this.testComplete=true;
        }
        // for saving benchmarking pre/post exercise 
        if(!this.testComplete){
          if (this.isPrePostExercise) {
            this.savePrePostExercise(item);
          } if(this.isAssessmentExercise) {
            this.saveAssessmentExercise();
          }
        }
        
        if (this.testComplete) {
          this.update();
        }
      }
    }

    this.slickModal.slickNext();
  }

  saveOnReview(event) {
    
    this.stopAllMediaPlayers();
    if (typeof event === 'object' && event !== null) {
      if (event.answer && !(event.answer === '{}' || (event.answer === undefined) || this.isEmptyJsonString(event.answer))) {
        this.answers[event.elementId] = event.answer;
        let item = { elementId: event.elementId, answer: event.answer, total: 0, points: 0 };
        this.updateAnswersArray(item);
        this.setUnAttemptedAnswersInCommunicationService();
        if (!this.isSelfAssessment) {
          this.saveExercise();
        }
      }
    }
  }

  saveExercise() {
    let obj = { courseId: this.courseId, exerciseId: this.currItem.id, answers: this.answersArray, timeSpent: this.timer.totalTime, programActivationId: this.programActivationId }
    this.subscriptions.add(this.dashboardService.saveExercise(obj).subscribe());
  }

  isEmptyJsonString(answer) {
    if (this.IsJsonString(answer)) {
      answer = JSON.parse(answer);
      if (answer) {
        return Object.keys(answer).every(el => answer[el].length == 0);
      }
    }

    return false;
  }

  IsJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  stopAllMediaPlayers() {
    let audios = document.getElementsByTagName('audio');
    for (let i = 0, len = audios.length; i < len; i++) {
      audios[i].pause();
    }
    this.stopAllVideo();
  }

  stopAllVideo() {
    let videos = document.getElementsByTagName('video');
    for (let i = 0, len = videos.length; i < len; i++) {
      videos[i].pause();
    }
    this.stopCameraTag = {
      change: this.stopCameraTag.change,
      stop: true
    }
  }


  startTimer(offsetTime: number = 0) {
    let count = 0;
    this.subscriptions.add(this.countupTimerService.interval.subscribe((value) => {
      if (value >= count) {
        count = value;
        value += offsetTime;
        this.timer.totalTime = value;
        this.timer.min = Math.floor(value / 60);
        this.timer.sec = Math.floor(value % 60);
      }
    }));
  }

  exerciseSaveEventAmplitude() {
    /* amplitude.getInstance().init(config.AMPLITUDE_API_KEY);
    amplitude.getInstance().setUserId(this.user.email);
    amplitude.getInstance().setUserProperties({ 'name': this.user.name, 'organization': this.user.organization, 'cohortName': (this.user['userGroup'] || '') });
    amplitude.getInstance().logEvent('Submit an exercise', { 'Course Title': this.courseTitle, 'exerciseTitle': this.exerciseData.title, 'exerciseName': this.exerciseData.name }); */
    // ga('send', 'event', {
    //   eventCategory: 'Learner Player',
    //   eventAction: 'Submit an exercise',
    //   eventLabel: `course: ${this.courseTitle}, exercise: ${this.exerciseData.title}`
    // });
    // mixpanel.track('Submit an exercise', {
    //   'Course Name': this.courseName,
    //   'Exercise Type': this.currItem.type,
    //   'Exercise Template Name': this.exerciseData.name,
    // });
  }


  getFixedEditor(j, element) {
    if (j > 0 && (this.exerciseData && this.exerciseData.pages && this.exerciseData.pages.length)) {
      let el = this.exerciseData.pages[0].elements.find(el => {
        let k = el.elementType.toLowerCase();
        if (el[k] && el[k].editorId && element && element.editorId) return el[k].editorId === element.editorId;
        else return false;
      });
      if (el) return el.editor;
    }
    return null;
  }

  backHandler() {
    this.slickModal.slickPrev();
  }

  goto() {
    this.showBackButton = true;
    this.slickModal.slickGoTo(0, false);
  }

  goToSlide(id) {
    this.stopAllVideo();
    if(this.exerciseData && this.exerciseData['elementCount']) {
      let i = this.exerciseData['elements'].findIndex(el => el._id == id);
      this.slickModal.slickGoTo(i, false);
      let currentSlideId = this.exerciseData['elements'][this.currentSlideNumber]._id;
      if (currentSlideId && currentSlideId != id) {
        this.store.set('qsResponse', currentSlideId);
      }
    }
  }

  slickChange(e) {
    this.scrolltoTop();
    this.currentSlideNumber = e.currentSlide;
    if (e && this.exerciseData && this.exerciseData.elements && this.exerciseData.elements.length && (e.currentSlide < this.exerciseData.elements.length)) {
      this.updateIndex(e.currentSlide);
    }
  }

  updateIndex(currentSlide) {
    this.slick.currentSlide = this.getIndexOfQuestion(currentSlide);
    if(this.exerciseData && this.exerciseData['elements'] && this.exerciseData['elements'].length) {
      this.activeNode = this.exerciseData['elements'][currentSlide]; 
      this.communicationService.changeNode(this.activeNode);
    }
  }

  getIndexOfQuestion(count) {
    this.currentSlideNumber = count;
    count = count + 1;
    let arr = this.exerciseData['elements'];
    if (arr && arr.length === 0) {
      return 0;
    }
    let editorCount = 0;
    for (let i = 1; i < count; i++) {
      if (arr[i - 1] && arr[i - 1].elementType === 'EDITOR') {
        editorCount += 1;
      }
    }
    return count - editorCount;
  }

  updateAnswersArray(item) {
    const i = this.answersArray.findIndex(_item => _item.elementId === item.elementId);
    if (i > -1) this.answersArray[i] = item;
    else this.answersArray.push(item);
  }

  toggleSlick() {
    this.showSlick = false;
    this.showSlick = true;
  }

  openVedioFeedbackModal() {
    const modalRef = this.modalService.open(QuestionVideoFeedbackComponent, {
      windowClass: 'modal-cntrl modal-cntrl-sm'
    });
    modalRef.componentInstance.data = {
      courseId: this.courseId,
      courseName: this.courseTitle,
      exerciseId: this.currItem.id,
      exerciseName: this.currItem.title,
      questionId: this.exerciseData && this.exerciseData.pages && this.exerciseData.pages.length && this.exerciseData.pages[0].elements[this.currentSlideNumber]._id,
      contentType: 'exercise'
    }
    if(this.exerciseData && this.exerciseData.pages && this.exerciseData.pages.length) {
      if (this.courseFeedback[this.exerciseData.pages[0].elements[this.currentSlideNumber]._id]) {
        modalRef.componentInstance.updateData = this.courseFeedback[this.exerciseData.pages[0].elements[this.currentSlideNumber]._id]
      }
      modalRef.componentInstance.feedbackResponse.subscribe((res) => {
        this.courseFeedback[this.exerciseData.pages[0].elements[this.currentSlideNumber]._id] = res;
      });
    }
  }

  openReportFeedback(ele: ElementType, index) {
    const modalRef = this.modalService.open(ReportFeedbackComponent, {
      windowClass: 'modal-cntrl modal-cntrl-sm'
    });
    modalRef.componentInstance.data = {
      courseId: this.courseId,
      courseName: this.courseTitle,
      exerciseId: this.exerciseData['_id'],
      exerciseName: this.exerciseData.name,
      questionId: ele._id,
      contentType: 'exercise',
      questionNumber: index
    }
    if(this.exerciseData && this.exerciseData.pages && this.exerciseData.pages.length) {
      if (this.courseFeedback[this.exerciseData.pages[0].elements[this.currentSlideNumber]._id]) {
        modalRef.componentInstance.updateData = this.courseFeedback[this.exerciseData.pages[0].elements[this.currentSlideNumber]._id]
      }
      modalRef.componentInstance.feedbackResponse.subscribe((res) => {
        this.courseFeedback[this.exerciseData.pages[0].elements[this.currentSlideNumber]._id] = res;
      });
    }
  }
  

  likeDislike(like, element, index) {
    let payload = {
      courseId: this.courseId,
      courseName: this.courseTitle,
      exerciseId: this.exerciseData['_id'],
      exerciseName: this.exerciseData.name,
      questionId: element._id,
      isliked: like,
      isFeedback: true
    }
    this.feedbackService.saveFeedback(payload).subscribe((res) => {
      this.courseFeedback[element._id] = res['data'];
      this.amplitudeLikeDislike(like, element.id, index);
    });
  }

  amplitudeLikeDislike(like, questionId, questionNumber) {
    // this.amplitudeIntialization();
    /* amplitude.getInstance().logEvent('likeDislike', {
      like: like,
      courseName: this.courseTitle,
      exerciseName: this.exerciseData.name,
      questionId: questionId,
      questionNumber: questionNumber
    }); */
  }

  getCourseFeedback(id) {
    if (this.courseFeedback && id) {
      return this.courseFeedback[id] || null;
    }
    return null;
  }

  setUnAttemptedAnswersInCommunicationService() {
    let unAttemptedQuestions = this.totalQuestions && this.totalQuestions.filter(q => this.answersArray.findIndex(ans => ans.elementId == q._id) == -1).map(el => ({ id: el._id }));
    if (unAttemptedQuestions) {
      if (unAttemptedQuestions.length === (this.totalQuestions.length - this.answersArray.length) || unAttemptedQuestions.length == 0) {
        this.communicationService.setUnAttemptedAnswerArray(unAttemptedQuestions);
      }
    }
  }

  openQuickGuide() {

  }

  /**
   * Save banchmarking pre and post exercise 
   */
  savePrePostExercise(item) {
    let obj = {
      programId: this.activationInfo.programId,
      activationId: this.activationInfo.programActivationId,
      exerciseType: this.exerciseType,
      exerciseId: this.exerciseData['exerciseId'],
      answers: this.answersArray, timeSpent: this.timer.totalTime
    }
    this.subscriptions.add(this.pathwayService.saveBenchmarkingPrePostExer(obj).subscribe());
  }

  saveAssessmentExercise() {
    let obj = {
      programDashboardId: this.programDashboardId,
      programActivationId: this.activationInfo.programActivationId,
      exerciseType: this.exerciseType,
      exerciseId: this.exerciseData['exerciseId'],
      answers: this.answersArray, timeSpent: this.timer.totalTime, contentCompleted: false
    }
    this.subscriptions.add(this.pathwayService.saveAssessmentExer(obj).subscribe());
  }
}
